import styled, { css } from 'styled-components'

type Props = {
	name: string
	span?: number
	place?: number
}

export const GridArea = styled.div<Props>`
	${({ name }) =>
		name &&
		css`
		grid-area: ${name};
	`}
`
